var _ellipse, _ellipse2, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _g, _circle30, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterLayoput(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 295,
    viewBox: "0 0 1440 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1153_535)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1153_535)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1153_535",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1130,
    y: 0,
    width: 3222,
    height: 930
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 481,
    cy: 465,
    rx: 1611,
    ry: 465,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1153_535)"
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 481,
    cy: 415,
    rx: 1611,
    ry: 465,
    fill: "url(#paint0_linear_1153_535)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1254.2 -56.4145C1525.98 -56.4145 1496.45 43.2256 1741.53 43.2256C1844.83 14.0565 1824.37 -117.079 1801.22 -179H849.828C455.299 -138.138 -271.422 -56.4145 -22.074 -56.4145C289.612 -56.4145 371.277 69 616.667 69C862.056 69 982.421 -56.4145 1254.2 -56.4145Z",
    fill: "url(#paint1_linear_1153_535)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1325.52,
    cy: 239.028,
    r: 6.73132,
    transform: "rotate(-45 1325.52 239.028)",
    fill: "#FFE10C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1339.78,
    cy: 224.766,
    r: 6.73132,
    transform: "rotate(-45 1339.78 224.766)",
    fill: "#FFE10C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1354.04,
    cy: 210.503,
    r: 6.73132,
    transform: "rotate(-45 1354.04 210.503)",
    fill: "#FFE10C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1368.31,
    cy: 196.24,
    r: 6.73132,
    transform: "rotate(-45 1368.31 196.24)",
    fill: "#FFE10C"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1382.57,
    cy: 181.978,
    r: 6.73132,
    transform: "rotate(-45 1382.57 181.978)",
    fill: "#FFE10C"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1396.83,
    cy: 167.715,
    r: 6.73132,
    transform: "rotate(-45 1396.83 167.715)",
    fill: "#FFE10C"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1339.78,
    cy: 253.291,
    r: 6.73132,
    transform: "rotate(-45 1339.78 253.291)",
    fill: "#FFE10C"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1354.04,
    cy: 239.028,
    r: 6.73132,
    transform: "rotate(-45 1354.04 239.028)",
    fill: "#FFE10C"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1368.31,
    cy: 224.766,
    r: 6.73132,
    transform: "rotate(-45 1368.31 224.766)",
    fill: "#FFE10C"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1382.57,
    cy: 210.503,
    r: 6.73132,
    transform: "rotate(-45 1382.57 210.503)",
    fill: "#FFE10C"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1396.83,
    cy: 196.24,
    r: 6.73132,
    transform: "rotate(-45 1396.83 196.24)",
    fill: "#FFE10C"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 1411.1,
    cy: 181.978,
    r: 6.73132,
    transform: "rotate(-45 1411.1 181.978)",
    fill: "#FFE10C"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 1354.04,
    cy: 267.554,
    r: 6.73132,
    transform: "rotate(-45 1354.04 267.554)",
    fill: "#FFE10C"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 1368.31,
    cy: 253.291,
    r: 6.73132,
    transform: "rotate(-45 1368.31 253.291)",
    fill: "#FFE10C"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 1382.57,
    cy: 239.028,
    r: 6.73132,
    transform: "rotate(-45 1382.57 239.028)",
    fill: "#FFE10C"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 1396.83,
    cy: 224.766,
    r: 6.73132,
    transform: "rotate(-45 1396.83 224.766)",
    fill: "#FFE10C"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 1411.1,
    cy: 210.503,
    r: 6.73132,
    transform: "rotate(-45 1411.1 210.503)",
    fill: "#FFE10C"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 1425.36,
    cy: 196.24,
    r: 6.73132,
    transform: "rotate(-45 1425.36 196.24)",
    fill: "#FFE10C"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 1368.31,
    cy: 281.816,
    r: 6.73132,
    transform: "rotate(-45 1368.31 281.816)",
    fill: "#FFE10C"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 1382.57,
    cy: 267.554,
    r: 6.73132,
    transform: "rotate(-45 1382.57 267.554)",
    fill: "#FFE10C"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 1396.83,
    cy: 253.291,
    r: 6.73132,
    transform: "rotate(-45 1396.83 253.291)",
    fill: "#FFE10C"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 1411.09,
    cy: 239.028,
    r: 6.73132,
    transform: "rotate(-45 1411.09 239.028)",
    fill: "#FFE10C"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 1425.36,
    cy: 224.766,
    r: 6.73132,
    transform: "rotate(-45 1425.36 224.766)",
    fill: "#FFE10C"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 1439.62,
    cy: 210.503,
    r: 6.73132,
    transform: "rotate(-45 1439.62 210.503)",
    fill: "#FFE10C"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 1382.57,
    cy: 296.079,
    r: 6.73132,
    transform: "rotate(-45 1382.57 296.079)",
    fill: "#FFE10C"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 1396.83,
    cy: 281.816,
    r: 6.73132,
    transform: "rotate(-45 1396.83 281.816)",
    fill: "#FFE10C"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 1411.1,
    cy: 267.554,
    r: 6.73132,
    transform: "rotate(-45 1411.1 267.554)",
    fill: "#FFE10C"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 1425.36,
    cy: 253.291,
    r: 6.73132,
    transform: "rotate(-45 1425.36 253.291)",
    fill: "#FFE10C"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 1439.62,
    cy: 239.028,
    r: 6.73132,
    transform: "rotate(-45 1439.62 239.028)",
    fill: "#FFE10C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1153_535",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -17,
    y: -51,
    width: 278,
    height: 282
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -17,
    y: 67.5554,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 -17 67.5554)",
    fill: "#15A0DC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -3.98633,
    y: 56.2644,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 -3.98633 56.2644)",
    fill: "#15A0DC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.02734,
    y: 44.9734,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 9.02734 44.9734)",
    fill: "#15A0DC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.041,
    y: 33.6825,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 22.041 33.6825)",
    fill: "#15A0DC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35.0547,
    y: 22.3915,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 35.0547 22.3915)",
    fill: "#15A0DC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48.0684,
    y: 11.1005,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 48.0684 11.1005)",
    fill: "#15A0DC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 61.082,
    y: -0.190552,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 61.082 -0.190552)",
    fill: "#15A0DC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 74.0957,
    y: -11.4814,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 74.0957 -11.4814)",
    fill: "#15A0DC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 87.1094,
    y: -22.7725,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 87.1094 -22.7725)",
    fill: "#15A0DC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 100.123,
    y: -34.0635,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 100.123 -34.0635)",
    fill: "#15A0DC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 113.135,
    y: -45.3545,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 113.135 -45.3545)",
    fill: "#15A0DC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1153_535)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 118.681,
    cy: 85.7543,
    r: 87.222,
    fill: "#34B5EC"
  }))), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.6673,
    cy: 58.9934,
    r: 87.222,
    fill: "#34B5EC"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1153_535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.835 109.57H289.745V88.1607H294.227V105.669H304.835V109.57ZM317.538 103.541L317.57 101.8C317.151 102.219 316.41 102.444 314.862 102.735C312.476 103.186 311.702 103.863 311.702 105.217C311.702 106.41 312.412 106.991 313.734 106.991C315.894 106.991 317.506 105.411 317.538 103.541ZM321.762 109.57H317.861C317.732 109.183 317.635 108.635 317.603 108.151C316.603 109.248 314.927 109.989 312.798 109.989C309.187 109.989 307.511 108.216 307.511 105.636C307.511 101.058 310.574 100.542 314.798 99.9617C316.893 99.6715 317.474 99.2523 317.474 98.1561C317.474 97.1243 316.442 96.5117 314.798 96.5117C312.895 96.5117 312.121 97.4467 311.928 98.8654H308.027C308.091 95.5766 309.897 93.2874 314.991 93.2874C320.021 93.2874 321.762 95.5444 321.762 99.5425V109.57ZM339.829 109.57H335.863V107.345C334.767 109.151 333.122 109.989 330.93 109.989C327.77 109.989 325.545 107.635 325.545 104.153V93.7065H329.737V103.508C329.737 105.507 330.639 106.475 332.413 106.475C334.541 106.475 335.669 104.959 335.669 102.864V93.7065H339.829V109.57ZM357.981 109.57H353.758V99.9617C353.758 97.5112 353.048 96.8341 351.049 96.8341C348.857 96.8341 347.793 98.0593 347.793 100.478V109.57H343.601V93.7065H347.599V96.028C348.567 94.2546 350.179 93.2874 352.726 93.2874C355.757 93.2874 357.981 95.1252 357.981 98.5752V109.57ZM371.811 103.831H376.035C375.584 107.507 372.585 109.989 368.748 109.989C364.428 109.989 361.461 107.12 361.461 101.445C361.461 95.7701 364.428 93.2874 368.877 93.2874C373.004 93.2874 375.81 95.6411 376.068 99.3813H371.844C371.618 97.7369 370.425 96.7696 368.845 96.7696C367.072 96.7696 365.621 97.8981 365.621 101.348C365.621 104.798 367.072 106.475 368.716 106.475C370.361 106.475 371.65 105.54 371.811 103.831ZM396.459 109.57H391.945V99.9617H383.595V109.57H379.113V88.1607H383.595V96.2215H391.945V88.1607H396.459V109.57ZM416.222 109.57H399.971V88.1607H415.706V91.9009H404.324V96.4794H414.803V100.252H404.324V105.765H416.222V109.57ZM426.067 87.9299C428.027 87.9299 429.643 88.1723 430.916 88.6573C432.189 89.122 433.139 89.8393 433.765 90.8092C434.392 91.7588 434.705 92.9611 434.705 94.4159C434.705 95.4059 434.513 96.2748 434.129 97.0224C433.765 97.7498 433.27 98.3762 432.644 98.9015C432.038 99.4066 431.381 99.8209 430.674 100.144L437.039 109.57H431.947L426.794 101.266H424.339V109.57H419.763V87.9299H426.067ZM425.734 91.6881H424.339V97.5376H425.824C426.835 97.5376 427.653 97.4265 428.279 97.2042C428.906 96.982 429.36 96.6486 429.643 96.2041C429.926 95.7393 430.068 95.1837 430.068 94.5371C430.068 93.8501 429.906 93.3046 429.583 92.9004C429.28 92.4761 428.805 92.173 428.158 91.9912C427.532 91.7891 426.724 91.6881 425.734 91.6881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1153_535)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1153_535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.81 73.2839C279.116 73.523 278.208 74.5394 277.944 75.3526C277.418 76.9668 277.406 78.5692 277.873 81.3912C278.303 84.0457 279.559 88.5777 280.886 92.2726L281.52 94.0662L282.441 94.0902C282.943 94.1021 283.385 94.0662 283.421 94.0065C283.457 93.9467 283.708 92.9183 283.959 91.7226C284.952 87.1428 285.98 83.986 288.192 78.7007C288.957 76.8712 288.802 76.4885 286.745 75.221C283.828 73.4393 281.328 72.7338 279.81 73.2839ZM266.621 86.2818C266.621 86.3297 266.919 87.3461 267.29 88.5418C267.661 89.7376 268.032 90.9573 268.115 91.2562C268.199 91.5551 268.342 91.9856 268.45 92.2248C268.641 92.6911 268.283 92.4998 276.139 96.3621C277.036 96.7926 277.143 96.9361 277.538 96.5056C277.801 96.1588 277.586 95.8719 276.928 94.7239C276.163 93.3727 275.075 91.4356 274.381 90.18C273.377 88.3625 272.982 87.8004 272.695 87.7407C272.3 87.657 267.218 86.3775 266.896 86.2818C266.74 86.246 266.621 86.246 266.621 86.2818ZM255.081 93.4803C254.484 93.7912 254.065 94.2456 253.204 95.561C251.327 98.4069 250.167 101.408 250.274 103.094C250.394 105.007 251.769 106.442 254.017 107.004C255.022 107.256 258.226 107.291 259.864 107.064C261.323 106.861 264.456 106.263 266.202 105.845C268.797 105.223 275.72 103.166 276.175 102.867C276.306 102.783 276.306 102.628 276.199 101.994C276.127 101.564 276.067 101.002 276.067 100.739C276.067 100.248 276.067 100.248 275.445 100.105C268.558 98.5264 265.269 97.4024 257.294 93.8988C255.787 93.2292 255.608 93.2053 255.081 93.4803ZM278.1 106.072C276.797 106.729 275.625 107.291 275.553 107.279C275.505 107.279 275.087 107.495 274.62 107.758C274.154 108.021 273.699 108.236 273.616 108.236C273.855 108.151 272.695 108.667 272.695 108.667L271.499 109.24C270.698 109.527 269.969 110.03 269.801 110.424C269.706 110.64 269.514 111.213 269.371 111.704C269.215 112.194 269.036 112.792 268.952 113.019C268.869 113.246 268.677 113.844 268.534 114.334C268.378 114.825 268.163 115.494 268.044 115.817L267.816 116.391L268.211 116.319L269.012 116.128L269.789 115.938L270.387 115.781L271.224 115.59L273.018 115.183C274.106 114.944 274.393 114.813 274.584 114.418C274.692 114.203 274.847 113.952 274.931 113.856C275.015 113.76 275.266 113.33 275.493 112.9C275.9 112.134 277.227 109.826 278.327 107.937C279.176 106.478 279.236 106.442 278.901 106.143C278.499 105.785 278.399 105.921 278.1 106.072ZM281.986 107.423C281.962 107.507 281.603 108.595 281.197 109.85C279.846 114.047 278.734 116.559 275.266 123.207C274.8 124.116 275.146 124.666 277.095 126.149C279.116 127.679 281.305 128.684 282.644 128.684C284.378 128.684 285.657 127.297 286.183 124.833C286.721 122.322 285.801 114.896 284.174 108.678L283.804 107.279H282.919C282.321 107.279 282.022 107.327 281.986 107.423Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1153_535",
    x: -1160,
    y: -15,
    width: 3282,
    height: 940,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0368861 0 0 0 0 0.486668 0 0 0 0 0.680973 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1153_535"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1153_535",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1153_535",
    x1: -34.5,
    y1: -50,
    x2: 245.489,
    y2: 856.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#34B5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#004D94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1153_535",
    x1: 477.438,
    y1: 80.3877,
    x2: 1413.17,
    y2: -280.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1153_535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 295,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1153_535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 57,
    fill: "white",
    transform: "translate(250 72)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1153_535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.9819,
    height: 56.44,
    fill: "white",
    transform: "translate(250 72.7219)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1153_535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.9819,
    height: 56.44,
    fill: "white",
    transform: "translate(250 72.7219)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLayoput);
export default __webpack_public_path__ + "static/media/footer-layoput.b37b8f0992406f3e3d75557bfff9b55c.svg";
export { ForwardRef as ReactComponent };